// Runtime application configuration.
//
// Values are resolved at runtime from `window.__APP_CONFIG__` (injected by
// public/generate-config.sh from Azure App Service Application Settings) and
// fall back to build-time `REACT_APP_*` values inlined by dotenv-webpack for
// local dev.
var _a, _b, _c, _d, _e, _f;
// Static references so dotenv-webpack can inline them at build time.
// (Dynamic `process.env[key]` access is NOT replaced by dotenv-webpack.)
const buildTimeConfig = {
    REACT_APP_API_BASE_URL: (_a = process.env.REACT_APP_API_BASE_URL) !== null && _a !== void 0 ? _a : "",
    REACT_APP_ENVIRONMENT: (_b = process.env.REACT_APP_ENVIRONMENT) !== null && _b !== void 0 ? _b : "",
    REACT_APP_APP_NAME: (_c = process.env.REACT_APP_APP_NAME) !== null && _c !== void 0 ? _c : "",
    REACT_APP_VERSION: (_d = process.env.REACT_APP_VERSION) !== null && _d !== void 0 ? _d : "",
    REACT_APP_DEBUG: (_e = process.env.REACT_APP_DEBUG) !== null && _e !== void 0 ? _e : "",
};
const runtimeConfig = (_f = window.__APP_CONFIG__) !== null && _f !== void 0 ? _f : {};
// Prefer a non-empty runtime value; otherwise fall back to the build-time value
// (handles an unset App Setting producing an empty string).
const get = (key) => runtimeConfig[key] || buildTimeConfig[key];
export const config = {
    apiBaseUrl: get("REACT_APP_API_BASE_URL"),
    environment: get("REACT_APP_ENVIRONMENT"),
    appName: get("REACT_APP_APP_NAME"),
    version: get("REACT_APP_VERSION"),
    debug: get("REACT_APP_DEBUG") === "true",
};
